import * as React from 'react';

import styles from './styles.module.scss';

const CarrierNotice: React.FC = () => {

	return (
		<div className={styles.noticeText}>
			SMS Message and data rates may apply. Carriers are not liable for delayed or undelivered messages. Message frequency varies.
			Send STOP to opt-out or HELP to get customer care contact details.
		</div>
	);
};

export default React.memo(CarrierNotice);
